<template>
  <div id="app">
    <!-- <audio ref="audioPlayer"  loop autoplay>
        <source src="./assets/4031.mp3" type="audio/mpeg">
        您的浏览器不支持 audio 元素。
      </audio> -->
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
